function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var VList = function () {
    function VList(_ref) {
        var el = _ref.el, getData = _ref.getData, itemHeight = _ref.itemHeight, createItem = _ref.createItem, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? 0 : _ref$overflow;
        _classCallCheck(this, VList);
        this.el = el;
        this.content = null;
        this.data = [];
        this.getData = getData;
        this.itemHeight = itemHeight;
        this.createItem = createItem;
        this.overflow = overflow;
        this.renderStart = -1;
        this.renderEnd = -1;
        this.viewStart = 0;
        this.viewEnd = 0;
        this.throttle = false;
        this.cleared = false;
        this.init();
        this.reload();
    }
    _createClass(VList, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.el.classList.add('vlist-container');
                this.content = document.createElement('div');
                this.content.classList.add('vlist-content');
                this.el.appendChild(this.content);
                this.el.addEventListener('scroll', function () {
                    console.log('scroll');
                    _this.cleared || _this.handleScroll();
                });
                this.el.addEventListener('touchmove', function (e) {
                    console.dir(_this.el.children[0].getBoundingClientRect().top);
                });
            }
        },
        {
            key: 'reload',
            value: function reload() {
                this.clear();
                this.data = this.getData();
                this.renderStart = -1;
                this.renderEnd = -1;
                this.viewStart = 0;
                this.viewEnd = 0;
                this.throttle = false;
                this.handleScroll();
                this.cleared = false;
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll() {
                if (!this.throttle) {
                    var clientH = this.el.clientHeight;
                    var scrollTop = this.el.scrollTop;
                    this.viewStart = this.getViewStart(scrollTop);
                    this.viewEnd = this.getViewEnd(scrollTop, clientH);
                    if (this.viewStart <= this.renderStart || this.viewEnd >= this.renderEnd) {
                        console.log('dfffff');
                        this.render(clientH, scrollTop);
                    }
                } else {
                }
            }
        },
        {
            key: 'render',
            value: function render(clientH, scrollTop) {
                var oldRenderStart = this.renderStart;
                var oldRenderEnd = this.renderEnd;
                this.renderStart = this.getViewStart(scrollTop) - this.overflow;
                this.renderEnd = this.getViewEnd(scrollTop, clientH) + this.overflow;
                if (this.renderStart < oldRenderStart) {
                    var beforeItems = document.createDocumentFragment();
                    var addFrom = Math.max(this.renderStart, 0);
                    var addTo = Math.min(oldRenderStart - 1, this.renderEnd, this.data.length - 1);
                    for (var i = addFrom; i <= addTo; i++) {
                        beforeItems.appendChild(this.createItem(this.data[i], i));
                    }
                    this.content.insertBefore(beforeItems, this.content.firstElementChild);
                } else {
                    var removeFrom = Math.max(oldRenderStart, 0);
                    var removeTo = Math.min(this.renderStart - 1, oldRenderEnd);
                    for (var _i2 = removeFrom; _i2 <= removeTo; _i2++) {
                        this.content.removeChild(this.content.firstElementChild);
                    }
                }
                if (this.renderEnd > oldRenderEnd) {
                    var afterItems = document.createDocumentFragment();
                    var _addFrom = Math.max(oldRenderEnd + 1, this.renderStart);
                    var _addTo = Math.min(this.renderEnd, this.data.length - 1);
                    for (var _i4 = _addFrom; _i4 <= _addTo; _i4++) {
                        afterItems.appendChild(this.createItem(this.data[_i4], _i4));
                    }
                    this.content.appendChild(afterItems);
                } else {
                    var _removeFrom = Math.min(oldRenderEnd, this.data.length - 1);
                    var _removeTo = Math.max(this.renderEnd + 1, oldRenderStart);
                    for (var _i6 = _removeFrom; _i6 >= _removeTo; _i6--) {
                        this.content.removeChild(this.content.lastElementChild);
                    }
                }
                this.content.style.paddingTop = ''.concat(this.renderStart > 0 ? this.renderStart * this.itemHeight : 0, 'px');
                this.content.style.paddingBottom = ''.concat(this.renderEnd < this.data.length - 1 ? (this.data.length - this.renderEnd - 1) * this.itemHeight : 0, 'px');
            }
        },
        {
            key: 'getViewStart',
            value: function getViewStart(scrollTop) {
                return Math.floor(scrollTop / this.itemHeight);
            }
        },
        {
            key: 'getViewEnd',
            value: function getViewEnd(scrollTop, clientH) {
                return Math.ceil((scrollTop + clientH) / this.itemHeight) - 1;
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.content.innerHTML = '';
                this.content.style.paddingTop = '0px';
                this.content.style.paddingBottom = '0px';
                this.cleared = true;
            }
        },
        {
            key: 'locateStart',
            value: function locateStart(n) {
                this.el.scrollTo({
                    top: n * this.itemHeight,
                    behavior: 'instant'
                });
            }
        },
        {
            key: 'locateEnd',
            value: function locateEnd(n) {
                this.el.scrollTo({
                    top: n * this.itemHeight - this.el.clientHeight,
                    behavior: 'instant'
                });
            }
        }
    ]);
    return VList;
}();